export const MAX_HEIGHT_OFFSET = 120;
